"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultDetail = function defaultDetail() {
  return {
    userId: null,
    jeequanReceiverId: '',
    receiverAlias: '',
    providerReceiverId: '',
    receiverBindStatus: '',
    receiverFailReason: '',
    lastSyncTime: ''
  };
};
var _default = exports.default = {
  name: 'UserDivisionConfigPanel',
  props: {
    userId: {
      type: Number,
      default: 0
    },
    initialReceiverId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      detailLoading: false,
      saveLoading: false,
      detail: defaultDetail(),
      form: {
        jeequanReceiverId: ''
      }
    };
  },
  computed: {
    hasUserId: function hasUserId() {
      return this.normalizeUserId(this.userId) > 0;
    },
    showFailReason: function showFailReason() {
      if (!this.detail.receiverFailReason) return false;
      var status = String(this.detail.receiverBindStatus || '').toUpperCase();
      return status !== 'BOUND' && status !== 'SUCCESS';
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler: function handler() {
        this.handleUserIdChange();
      }
    },
    initialReceiverId: function initialReceiverId(value) {
      if (!this.hasUserId) {
        this.form.jeequanReceiverId = value || '';
      }
    }
  },
  methods: {
    handleUserIdChange: function handleUserIdChange() {
      if (!this.hasUserId) {
        this.resetPanel();
        return;
      }
      this.form.jeequanReceiverId = this.initialReceiverId || '';
      this.loadDetail();
    },
    normalizeUserId: function normalizeUserId(value) {
      var userId = Number(value);
      if (Number.isNaN(userId) || userId <= 0) return 0;
      return userId;
    },
    resetPanel: function resetPanel() {
      this.detail = defaultDetail();
      this.form.jeequanReceiverId = this.initialReceiverId || '';
    },
    syncFromDetail: function syncFromDetail(detail) {
      var nextDetail = detail || {};
      this.detail = _objectSpread(_objectSpread({}, defaultDetail()), nextDetail);
      this.form.jeequanReceiverId = this.detail.jeequanReceiverId || '';
      this.emitUpdated();
    },
    emitUpdated: function emitUpdated() {
      this.$emit('updated', _objectSpread(_objectSpread({}, this.detail), {}, {
        jeequanReceiverId: this.form.jeequanReceiverId || ''
      }));
    },
    loadDetail: function loadDetail() {
      var _this = this;
      var userId = this.normalizeUserId(this.userId);
      if (!userId) return;
      this.detailLoading = true;
      (0, _user.userDivisionConfigApi)(userId).then(function (res) {
        _this.syncFromDetail(res);
      }).catch(function () {
        _this.resetPanel();
      }).finally(function () {
        _this.detailLoading = false;
      });
    },
    handleSave: function handleSave() {
      var _this2 = this;
      var userId = this.normalizeUserId(this.userId);
      if (!userId) return;
      this.saveLoading = true;
      (0, _user.userDivisionConfigUpdateApi)({
        userId: userId,
        jeequanReceiverId: this.form.jeequanReceiverId
      }).then(function () {
        _this2.$message.success('分账信息保存成功');
        _this2.loadDetail();
      }).finally(function () {
        _this2.saveLoading = false;
      });
    },
    displayValue: function displayValue(value) {
      if (value === undefined || value === null || value === '') return '-';
      return value;
    },
    statusText: function statusText(status) {
      var statusMap = {
        BOUND: '已绑定',
        SUCCESS: '已绑定',
        PENDING: '绑定中',
        PROCESSING: '处理中',
        FAILED: '绑定失败',
        FAIL: '绑定失败',
        ERROR: '绑定异常',
        UNBOUND: '未绑定',
        NOT_FOUND: '未找到记录'
      };
      var normalizedStatus = String(status || '').toUpperCase();
      return statusMap[normalizedStatus] || this.displayValue(status);
    },
    statusTagType: function statusTagType(status) {
      var statusMap = {
        BOUND: 'success',
        SUCCESS: 'success',
        PENDING: 'warning',
        PROCESSING: 'warning',
        FAILED: 'danger',
        FAIL: 'danger',
        ERROR: 'danger',
        UNBOUND: 'info',
        NOT_FOUND: 'info'
      };
      return statusMap[String(status || '').toUpperCase()] || 'info';
    },
    formatTime: function formatTime(value) {
      if (!value) return '-';
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      var pad = function pad(num) {
        return String(num).padStart(2, '0');
      };
      return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds()));
    }
  }
};